import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AllergiesListBody from "components/PatientManagement/Allergies/AllergiesListBody";

export default function Allergies() {
  useEffect(() => {
    document.title = "Allergies";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <AllergiesListBody />
    </main>
  );
}
